export const TEAM_INVITATION_STATUS_REVOKED = 'revoked';
export const TEAM_INVITATION_STATUS_EXPIRED = 'expired';
export const TEAM_INVITATION_STATUS_USED = 'used';
export const TEAM_INVITATION_STATUS_INVALID = 'invalid';
export const TEAM_INVITATION_STATUS_MISMATCHED_EMAIL = 'mismatched-email';
export const TEAM_INVITATION_STATUS_MEMBER_COUNT_EXCEEDED =
  'member-count-exceeded';
